<template>
  <div>
    <div
      :style="{ width: getPercent + 'px', backgroundColor: color }"
      class="bar"
      :class="[back ? 'backBar' : 'frontbar']"
    ></div>
    <div v-if="text">
      <div v-if="back" class="text">
        <span>{{ val | fixed }}/</span>
        <span>{{ max | fixed }}</span>
      </div>
      <div v-show="val > 0" v-else class="fronttext">
        <span>{{ val | fixed }}/</span>
        <span>{{ max | fixed }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    val: Number,
    back: Boolean,
    max: Number,
    color: String,
    text: Boolean,
  },
  filters: {
    fixed(a) {
      return a.toFixed(2).replace(/\.?0+$/, "");
    },
  },
  computed: {
    getPercent() {
      return (this.val / this.max) * 200;
    },
  },
};
</script>

<style scoped>
.bar {
  position: absolute;
  bottom: 0px;
  left: 0px;
  transition: all 0.2s;
}

.backBar {
  height: 100%;
  z-index: 1;
}

.frontbar {
  height: 3px;
  z-index: 3;
}

.fronttext {
  position: absolute;
  z-index: 3;
  font-size: 10px;
  bottom: 0px;
  transform: translate(0, 2px);
  left: 40%;
}

.text {
  position: absolute;
  z-index: 2;
  font-size: 20px;
  bottom: 0px;
  margin: 10px;
  left: 40%;
}
</style>